import storeEvent from '../../utils/store-event';
import MainComp from '../str-main/component';

const KEY = 'str-category-tree';
const CLS = {
    root: KEY
};

export default class {
    onCreate(input) {
        this.categories = input.categories;
    }
    onMount() {
        // Close all lists when "All Categories" link is clicked
        const root = this.getEl(KEY);
        const item = root.querySelectorAll(':scope > li')[0];
        storeEvent.allCatsLinkClicked.listen(() => {
            closeList(item);
            closeOtherLists(item);
        });
    }
    onInput() {
        return {
            categories: this.categories
        };
    }
    handleClick(evt) {
        evt.preventDefault();
        const button = evt.target.closest('button');
        const link = evt.target.closest('a');
        if (button) { // Open and close sub-categories
            const item = button.closest('li');
            toggleList(item);
        } else if (link) {
            const item = link.closest('li');
            loadCategoryView(link.href, evt);
            openList(item);
            closeOtherLists(item);
        }
    }
}

function toggleList(item) {
    if (item) {
        if (item.getAttribute('aria-expanded') !== 'true') {
            openList(item);
            closeOtherLists(item);
        } else {
            closeList(item);
        }
    }
}

function loadCategoryView(href, evt) {
    MainComp.sendCategoryFilterEvent({
        url: href,
        clickEvent: evt
    });
}

function openList(item) {
    const hasSublist = item.querySelector('ul');
    if (hasSublist) {
        item.setAttribute('aria-expanded', true);
        setAriaHiddenOnSublists(item, false);
    }
}

// Close list and all sublists
function closeList(item) {
    const hasSublist = item.querySelector('ul');
    if (hasSublist) {
        item.setAttribute('aria-expanded', false);
        setAriaHiddenOnSublists(item, true);

        const subItems = item.querySelectorAll('li');
        for (let i = 0, n = subItems.length; i < n; i++) {
            const subItem = subItems[i];
            subItem.setAttribute('aria-expanded', false);
            setAriaHiddenOnSublists(subItem, true);
        }
    }
}

function setAriaHiddenOnSublists(item, isHide) {
    const lists = item.querySelectorAll(':scope > ul');
    for (let i = 0, n = lists.length; i < n; i++) {
        lists[i].setAttribute('aria-hidden', isHide);
    }
}

function closeOtherLists(item) {
    const list = item.closest('ul');
    // Only act on items that are direct children of root
    if (list.classList.contains(CLS.root)) {
        const items = list.querySelectorAll(':scope > li');
        for (let i = 0, n = items.length; i < n; i++) {
            if (items[i] !== item) {
                closeList(items[i]);
            }
        }
    }
}
